import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Card, CardContent, CardDescription, CardHeader, CardTitle, Button } from "@tellescope/ui";
import { Smartphone, Globe } from "lucide-react";
import { MOBILE_RETURN_SCHEME_KEY, MOBILE_AUTH_TOKEN_KEY } from "./useMobileAppLogin";
import { isAllowedMobileReturnScheme } from "./mobileReturnScheme";

export const MobileAppSuccessPage = () => {
  const { t } = useTranslation("auth");
  const navigate = useNavigate();

  const returnScheme = sessionStorage.getItem(MOBILE_RETURN_SCHEME_KEY) ?? "";
  const authToken = sessionStorage.getItem(MOBILE_AUTH_TOKEN_KEY) ?? "";
  const isValid = !!returnScheme && isAllowedMobileReturnScheme(returnScheme) && !!authToken;

  const handleOpenApp = () => {
    sessionStorage.removeItem(MOBILE_RETURN_SCHEME_KEY);
    sessionStorage.removeItem(MOBILE_AUTH_TOKEN_KEY);
    window.location.href = `${returnScheme}?token=${authToken}`;
  };

  const handleStayInBrowser = () => {
    sessionStorage.removeItem(MOBILE_RETURN_SCHEME_KEY);
    sessionStorage.removeItem(MOBILE_AUTH_TOKEN_KEY);
    navigate("/dashboard", { replace: true });
  };

  if (!isValid) {
    navigate("/dashboard", { replace: true });
    return null;
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-8">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CardTitle className="text-2xl font-bold">{t("You're signed in")}</CardTitle>
          <CardDescription>{t("How would you like to continue?")}</CardDescription>
        </CardHeader>
        <CardContent className="space-y-3">
          <Button className="w-full h-14 justify-start gap-3" onClick={handleOpenApp}>
            <Smartphone className="w-5 h-5 shrink-0" />
            <div className="text-left">
              <div className="font-medium">{t("Open in the app")}</div>
              <div className="text-xs opacity-75">{t("Return to the mobile app")}</div>
            </div>
          </Button>
          <Button variant="outline" className="w-full h-14 justify-start gap-3" onClick={handleStayInBrowser}>
            <Globe className="w-5 h-5 shrink-0" />
            <div className="text-left">
              <div className="font-medium">{t("Continue in browser")}</div>
              <div className="text-xs text-muted-foreground">{t("Stay on the web version")}</div>
            </div>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};
